import { BomItemPointer } from 'model/Project/BomItemPointer'
import {
  BoMItemActivityArticleDto,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { bomItemAllActivitiesSelector } from './allBomItemActivitiesSelector'

/**
 * Select the article of a BoM item for a specific working step
 * If the working step does not support articles, the raw material article is returned
 * @param bomItemPointer bomItemPointer
 * @param workingStepType workingStepType
 * @returns article
 */
export const bomItemArticlePerWorkingStepSelector =
  (
    bomItemPointer: BomItemPointer,
    workingStepType: WorkingStepType,
    /**
     * when provided, resolves the exact activity by id instead of matching
     * by working step type, to correctly disambiguate between multiple
     * activities that share the same working step type
     */
    activityId?: string,
  ) =>
  (state: RootAppState): BoMItemActivityArticleDto | undefined => {
    const bomItemActivities =
      bomItemAllActivitiesSelector(bomItemPointer)(state)

    const activityWithWorkingStep = activityId
      ? bomItemActivities.find((activity) => activity.id === activityId)
      : bomItemActivities.find(
          (activity) => activity.primaryWorkingStep === workingStepType
        )

    if (!activityWithWorkingStep) {
      return null
    }

    if (activityWithWorkingStep.supportsArticle) {
      return activityWithWorkingStep.article
    } else {
      return bomItemActivities.find((x) => x.usesRawMaterial)?.article
    }
  }
